<div class="view-container">
  <mat-card class="stocktake-view-card">
    <div class="stocktake-view-card__header">
      <div class="stocktake-view-card__title-row">
        <div class="stocktake-view-card__icon">
          <mat-icon>fact_check</mat-icon>
        </div>
        <div>
          <h1 class="stocktake-view-card__title">Stocktake</h1>
          <p class="stocktake-view-card__subtitle">Select a medicine and scan barcodes to reconcile stock</p>
        </div>
      </div>
    </div>

    @if (medicineVisable) {
      <form class="stocktake-view-card__form" [formGroup]="stocktakeForm">
        <div class="row g-2">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="stocktake-view-card__field">
              <mat-label>Search for medicine</mat-label>
              <input
                required
                [disabled]="isLoading"
                type="text"
                placeholder="Search for medicine"
                aria-label="Search for medicine"
                matInput
                formControlName="medicine"
                [matAutocomplete]="auto"
              />
              <mat-autocomplete
                (optionSelected)="medicineSelected($event)"
                autoActiveFirstOption
                #auto="matAutocomplete"
              >
                @for (med of medicine; track med) {
                  <mat-option [value]="med">
                    {{ med.name }}
                  </mat-option>
                }
              </mat-autocomplete>
              <mat-icon matPrefix>search</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="outline" class="stocktake-view-card__field">
              <mat-label>Select package type</mat-label>
              <mat-select
                required
                [disabled]="isLoading || medicineDosageTypePackageTypes.length === 0"
                formControlName="packageTypeId"
              >
                @for (type of medicineDosageTypePackageTypes; track type) {
                  <mat-option value="{{ type.id }}">
                    {{ type.package_type.type }} ({{ type.contained_quantity }})
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="stocktake-view-card__field">
              <mat-label>Dosage type</mat-label>
              <mat-select
                required
                [disabled]="isLoading || !selectedMedicine"
                formControlName="dosageTypeId"
                (selectionChange)="getMedicineDosagePackageTypes($event)"
              >
                @for (type of dosageTypes; track type) {
                  <mat-option [value]="type.id">
                    {{ type.additional_information }}
                  </mat-option>
                }
              </mat-select>
              @if (stocktakeForm.get('dosageTypeId')?.invalid) {
                <mat-error>Dosage type is invalid</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </form>

      <div class="stocktake-view-card__footer">
        <button
          type="button"
          mat-flat-button
          color="primary"
          class="stocktake-view-card__btn--primary"
          (click)="setItem()"
        >
          <mat-icon>qr_code_scanner</mat-icon>
          Start scanning
        </button>
      </div>
    }

    @if (barcodeVisable) {
      <div class="stocktake-view-card__context">
        <div class="stocktake-view-card__context-item">
          <span class="stocktake-view-card__context-label">Medicine</span>
          <span class="stocktake-view-card__context-value">{{ stocktakeForm.value.medicine }}</span>
        </div>
        <div class="stocktake-view-card__context-item">
          <span class="stocktake-view-card__context-label">Dosage type</span>
          <span class="stocktake-view-card__context-value">{{ dosageTypeName }}</span>
        </div>
        <div class="stocktake-view-card__context-item">
          <span class="stocktake-view-card__context-label">Package type</span>
          <span class="stocktake-view-card__context-value">
            {{ packageTypeName?.package_type?.type }} ({{ packageTypeName?.contained_quantity }})
          </span>
        </div>
      </div>

      <form class="stocktake-view-card__form" [formGroup]="barcodeForm">
        @if (doneScanVisable) {
          <mat-form-field appearance="outline" class="stocktake-view-card__field stocktake-view-card__field--barcode">
            <mat-label>Barcode</mat-label>
            <input
              [disabled]="barcodeDisabled"
              required
              matInput
              id="barcodeInput"
              [formControl]="barcodeValidate"
              placeholder="Scan or enter barcode"
              #barcodeInput
            />
            <button
              (click)="checkBarcode()"
              title="Click to scan"
              matSuffix
              class="stocktake-view-card__scan-trigger hide-button"
              mat-icon-button
              type="button"
            >
              click to scan
            </button>
            @if (barcodeValidate.invalid) {
              <mat-error>Barcode is not valid</mat-error>
            }
            <mat-hint>Examples AMI001001, BOLT02523, ABC2345-003</mat-hint>
          </mat-form-field>
        }

        <div class="stocktake-view-card__scan-count">
          Scan count: <strong>{{ scanCount }}</strong>
        </div>
      </form>

      @if (doneScanVisable) {
        <div class="stocktake-view-card__footer">
          <button
            type="button"
            mat-flat-button
            color="primary"
            class="stocktake-view-card__btn--primary"
            (click)="checkData()"
          >
            <mat-icon>check</mat-icon>
            Done
          </button>
        </div>
      }

      @if (additionalInfoVisable) {
        <div class="stocktake-view-card__additional">
          <h2 class="stocktake-view-card__section-title">Additional information</h2>
          <form [formGroup]="additionalInfoForm">
            <quill-editor
              formControlName="additional_information"
              format="text"
              [styles]="{ minHeight: '100px' }"
            >
            </quill-editor>
          </form>
        </div>

        <div class="stocktake-view-card__footer">
          <button
            type="button"
            mat-flat-button
            color="primary"
            class="stocktake-view-card__btn--primary"
            (click)="submitData()"
          >
            <mat-icon>save</mat-icon>
            Save
          </button>
        </div>
      }
    }
  </mat-card>
</div>
